import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import withStyles from '@material-ui/core/styles/withStyles';

import Lexicon from '../components/lexicon';
import Movement from '../components/movement';
// import Routine from '../components/routine';
// import BatchEdit1 from '../components/grid';

import { Link, Grid, Container } from '@material-ui/core';
import { Tab, Tabs } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Divider from '@material-ui/core/Divider';
import CodeIcon from '@material-ui/icons/Code'
import IconButton from '@material-ui/core/IconButton';
import Fab from '@material-ui/core/Fab';

const styles = (theme) => ({
	root: {
		display: 'flex'
	},
	content: {
		marginTop: 140,
		flexGrow: 1,
		padding: theme.spacing(3)
	},
	topSpace: {
		marginTop: 100
	},
	uiProgess: {
		position: 'fixed',
		zIndex: '1000',
		height: '31px',
		width: '31px',
		left: '50%',
		top: '35%'
	},
	appBar: {
		zIndex: theme.zIndex.drawer + 1,
		background: '#000200',
		color: theme.palette.secondary.main
	},
	toolbar: theme.mixins.toolbar,
	left: {
		color: theme.palette.primary.main
	},
	right: {
		flex: 1,
		display: 'flex',
		justifyContent: 'flex-end',
	},
	rightLink: {
		fontSize: 14,
		marginLeft: theme.spacing(2),
		whiteSpace: 'normal',
		fontWeight: 700
	},
	horizontalList: {
		display: 'inline-block',
	},
	whiteSpace: {
		height: 20
	},
	landing: {
		marginTop: 80,
		padding: 40,
		height: '90vh',
	},
	hometile: {
		background: `url('./unnamed.jpg')`,
		backgroundPosition: 'center',
		backgroundSize: 'contain',
		backgroundRepeat: 'no-repeat',
		height: 'auto',
		width: '100%'
	},
	img: {
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
  },
});

const menuNames = ["", "Movements", "Lexicon", "About"];

function a11yProps(index,v) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
		'aria-selected': (index === v ? 'true' : 'false'),
		name: index,
		index: index,
		selected: (index === v ? 'true' : 'false'),
	};
}

class exhibit extends Component {
	state = {
		render: false,
		page: 'Lexicon',
		value: 0
	};

	constructor(props) {
		super(props);
		var x = window.location.pathname.substring(1)
		// if (x.includes("/")){
		// 	x = x.split("/")[0];
		// }
		
		var y = menuNames.map(x => x.toLowerCase()).indexOf(x);

		this.state = {
			uiLoading: false,
			imageLoading: false,
			page: y,
		};
	}
	
	render() {
		const { classes } = this.props;

		if (this.state.uiLoading === true) {
			return (
				<div className={classes.root}>
					{this.state.uiLoading && <CircularProgress size={150} className={classes.uiProgess} />}
				</div>
			);
		} else {
			

			return (
				// show the top menu when landing page
				<div className={(window.location.pathname === "/" ?  (classes.root, classes.landing) : classes.root )}>
					<CssBaseline />
					<AppBar position="fixed" className={classes.appBar}>
						<Toolbar className={classes.toolbar}> 
							<div className={classes.left} key="topleft" />
								<Link
									variant="h6"
									underline="none"
									color="textPrimary"
									className={classes.title}
									href="/"
								>
									{'Minimum Movement Catalog'}
								</Link>
								<div className={classes.right} key="topmiddle" > 
							
								</div>
									{/* onClick={() => {}} */}
								<div className={classes.right} key="topright" > 
									<IconButton  aria-label="source code" target="_blank" href="http://github.com/DataMascara/mimo_cat">
										<CodeIcon />
									</IconButton>
								</div>
						</Toolbar>
						<Divider />

							<Tabs value={this.state.page}
								// onChange={this.changeTab}
								name={this.state.value}
								centered 
								indicatorColor="secondary"
								aria-label="tabs">
								<Tab label="Home"  href="/" {...a11yProps(0,this.state.page)} key="0" index={0} />
								<Tab label="Movements"  href="/movements" {...a11yProps(1,this.state.page)} key="1" index={1} />
								<Tab label="Lexicon" href="/lexicon" {...a11yProps(2,this.state.page)} key="2" index={2} />
								{/* <Tab label="About" href="/about" {...a11yProps(3,this.state.page)} key="3" index={3} /> */}
							</Tabs>

					</AppBar>


					<Route exact path="/">
					<Container>
						<Grid container spacing={3} key="home-main">
							<Grid item xs={12} sm={12} md={12} key="logo" className={classes.none}>
									<br/>
									<br/>
									<img className={classes.img} alt="complex" src="./unnamed.jpg" />
							</Grid>
							<Grid item xs={12}>
							<Grid container spacing={3}>
								
								<Grid item xs={12}>
									<Typography variant="h5" component="h1" gutterBottom>
										<b>About</b>
									</Typography>
								</Grid>
								<Grid item xs={12}>
								<Typography variant="body2" component="p" gutterBottom>
									This is an online movement lexicon created by interdisciplinary artist Maho Ogawa in collaboration with Katherine Chuang.
								</Typography>
								</Grid>
								<Grid item xs={12}>
								<Typography variant="body2" component="p" gutterBottom>
								This movement lexicon consists of 89 movement video clips in eight categories, started as research about Ogawa's Japanese-ness through body language, by archiving movements from the West and East, examining the kinetic and symbolic meaning of each movement language. 
									<br />
								</Typography>
								</Grid>
								<Grid item xs={12}>
								<Typography variant="body2" component="p" gutterBottom>
								This movement lexicon is used as a movement notation in the creative process of Ogawa's video/ live performances, teaching method for movement classes, and shared with the audience/viewers as process art.
									<br />
									<br />
								</Typography>
								</Grid>
								<Grid item xs={12}>
								<Typography component="p" variant="body2" gutterBottom>
									Maho Ogawa <br />
									<Link href="https://www.suisoco.com" variant="body2">www.suisoco.com</Link> 
									
									<br />
								</Typography>
								</Grid>
								</Grid>
								
							</Grid>
							
							
						</Grid>
						</Container>
					</Route>

					<Container>
					<Grid container spacing={10} className={classes.topSpace} key="gridall">
						<Grid item xs={12}>
							<div>
							{/* <Route exact path="/routines">
								<Routine/>
							</Route> */}
							<Route exact path="/movements">
									<Movement />
							</Route>
							<Route path="/lexicon">
								<Lexicon />
							</Route>
							{/* <Route exact path="/admin">
								<BatchEdit1 />
							</Route> */}

							</div>
						</Grid>
					</Grid>
					</Container>

				</div>

			);
		}
	}
}

export default withStyles(styles)(exhibit);
